
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import item from './lista-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Item: Cliente;
        @Prop() public Items: Cliente[];
        @Prop() public Seleccionado: number;
        @Prop() public Busqueda: string;
        @Prop() public Estado: string;
        public BuscarEnTodaLaDescripcion: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


        }

    }
